import React from 'react'
import { FormattedMessage } from 'react-intl'
import LinkStyleButton from '@src/components/LinkStyleButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

interface TableRowDetailWithExpansionProps {
  isExpanded: boolean
  id: string
  onClick: (e: string) => void
}
const TableRowDetailWithExpansion: React.FC<
  TableRowDetailWithExpansionProps
> = ({ isExpanded, id, onClick }) => {
  const toggleExpanded = () => {
    onClick(id)
  }
  return (
    <LinkStyleButton onClick={toggleExpanded} aria-expanded={false}>
      <FormattedMessage id="DETAILS" defaultMessage="Details" />

      {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    </LinkStyleButton>
  )
}
export default TableRowDetailWithExpansion
